const getPSXUser = async () => import('./index');

export const userFraudInfo = async () => (await getPSXUser()).userFraudInfo();
export const userFraudInfoEnhanced = async () => (await getPSXUser()).userFraudInfoEnhanced(); 
export const isUserFraudulent = async (isUserVerified: boolean, actionType: string) => (await getPSXUser()).isUserFraudulent(isUserVerified, actionType);
export const isUserFraudulentEnhanced = async (actionType?: string) => (await getPSXUser()).isUserFraudulentEnhanced(actionType);

export { off, on, once } from '../components/utils/events';
